/**
 * Shared service-role Supabase client (singleton — avoids GoTrue duplicate warnings on HMR).
 */

import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_SERVICE_ROLE_KEY } from '../config/env';

const memoryStorage = {
  getItem: () => null,
  setItem: () => {},
  removeItem: () => {},
};

const globalKey = '__roadserve_service_role_supabase__';
const serviceRoleAuthStorageKey = 'roadserve-service-role-auth-v2';

function createServiceRoleClient() {
  return createClient(SUPABASE_URL, SUPABASE_SERVICE_ROLE_KEY, {
    auth: {
      persistSession: false,
      autoRefreshToken: false,
      detectSessionInUrl: false,
      storage: memoryStorage,
      storageKey: serviceRoleAuthStorageKey,
    },
  });
}

function getServiceRoleClient() {
  if (typeof globalThis !== 'undefined' && globalThis[globalKey]) {
    return globalThis[globalKey];
  }
  const client = createServiceRoleClient();
  if (typeof globalThis !== 'undefined') {
    globalThis[globalKey] = client;
  }
  return client;
}

export const serviceRoleClient = getServiceRoleClient();
